import MapView from '@arcgis/core/views/MapView';
import { ArcgisMapLifecycle } from '../components/arcgis-map/constants/map-life-cycle.interface';
import { MainMapService } from '../components/arcgis-map/services/main-map.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ResultsMapService extends MainMapService implements ArcgisMapLifecycle {
	onRightClick(view: MapView, event: any): void {
		
	}

	override configureMapView(view: MapView | undefined): void {
		super.configureMapView(view);
		if (!view) return;

		view.extent = this.internalUser ? {
			xmin: 130000,
			ymin: 370000,
			xmax: 280000,
			ymax: 800000,
			spatialReference: { wkid: 2039 }
		} : {
			xmin: 3750000,
			ymin: 3400000,
			xmax: 4050000,
			ymax: 3950000,
			spatialReference: { wkid: 3857 }
		};
	}
}